// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-document-template-edit-general .ExtraDataSpace .mat-mdc-form-field {
  width: 100%;
}
.fi-document-template-edit-general .ExtraDataSpace .mat-mdc-form-field textarea {
  resize: none;
}`, "",{"version":3,"sources":["webpack://./Source/app/document-template/document-template-edit-general/document-template-edit-general.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;AAAR;AACQ;EACI,YAAA;AACZ","sourcesContent":[".fi-document-template-edit-general {\r\n    .ExtraDataSpace .mat-mdc-form-field {\r\n        width: 100%;\r\n        textarea {\r\n            resize: none;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
